// extracted by mini-css-extract-plugin
module.exports = {"container":"video_container__PLEuS","tv_frame":"video_tv_frame__inoNn","video_container":"video_video_container__EcERk"};